import { render, staticRenderFns } from "./_notifications.vue?vue&type=template&id=5519093e&"
import script from "./_notifications.vue?vue&type=script&lang=ts&"
export * from "./_notifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5519093e')) {
      api.createRecord('5519093e', component.options)
    } else {
      api.reload('5519093e', component.options)
    }
    module.hot.accept("./_notifications.vue?vue&type=template&id=5519093e&", function () {
      api.rerender('5519093e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/molecules/_notifications.vue"
export default component.exports